var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{class:_vm.buttonClass,on:{"click":_vm.buttonClick}},[_vm._v(" Sign and Authorize Order ")])])}
var staticRenderFns = []

export { render, staticRenderFns }